import { useState } from 'react';
import { api } from '../../services/api';
import { Business } from '../../services/types';
import '../../styles/invitation.css';

type InvitationResponse = { message: string; ownerEmail: string; delivery: string };

export function InvitationDialog({ business, token, onClose }: { business: Business; token: string; onClose: () => void }) {
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [message, setMessage] = useState('');

  async function resend() {
    setSending(true);
    setMessage('');
    try {
      const result = await api<InvitationResponse>(`/businesses/${business.id}/resend-invitation`, token, { method: 'POST' });
      setSent(true);
      setMessage(result.message);
    } catch (failure) {
      setMessage(failure instanceof Error ? failure.message : 'No pudimos reenviar la invitación.');
    } finally {
      setSending(false);
    }
  }

  return <div className="overlay inviteOverlay" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
    <section className="inviteDialog" role="dialog" aria-modal="true" aria-labelledby="invite-title">
      <button className="inviteClose" type="button" onClick={onClose} aria-label="Cerrar">×</button>
      <div className={`inviteIcon ${sent ? 'sent' : ''}`}>{sent ? '✓' : '✉'}</div>
      <small>{sent ? 'INVITACIÓN ENVIADA' : 'ACCESO AL PANEL'}</small>
      <h2 id="invite-title">{sent ? 'Ya va en camino.' : 'Reenviar invitación'}</h2>
      <p>{sent ? message : <>Crearemos una contraseña temporal nueva para el propietario de <strong>{business.name}</strong> y Cognito enviará el correo de bienvenida.</>}</p>
      <div className="inviteRecipient"><span>Se enviará a</span><strong>{business.ownerEmail}</strong></div>
      {!sent && <div className="inviteNotice"><i>i</i><span>La invitación anterior dejará de ser válida. Podrás reenviarla cuantas veces necesites, dejando al menos 5 minutos entre envíos.</span></div>}
      {message && !sent && <div className="error">{message}</div>}
      <div className="inviteActions">
        {sent ? <button className="primary" type="button" onClick={onClose}>Listo</button> : <><button type="button" onClick={onClose}>Cancelar</button><button className="primary" type="button" onClick={resend} disabled={sending}>{sending ? 'Enviando…' : 'Reenviar invitación'}</button></>}
      </div>
    </section>
  </div>;
}
